<template>
  <q-layout view="hHh Lpr lFf">
    <q-layout-header>
      <notification-bar />
      <accessibility-menu />
      <simple-header-tool-bar
        v-bind="headerToolBarBinds"
        @openMenu="leftDrawerOpen = !leftDrawerOpen"
      >
        <q-btn
          v-if="buttonIcon"
          slot="buttons"
          :data-test="CypressTarget('Menu')"
          flat
          sparse
          :icon="buttonIcon"
          @click="helpModal = true"
        />
      </simple-header-tool-bar>
    </q-layout-header>
    <q-page-container
      :style="__cordovaFixQPageContainerStyle"
    >
      <router-view />
    </q-page-container>
    <q-layout-drawer
      v-model="leftDrawerOpen"
      content-class="bg-grey-2"
    >
      <main-menu
        v-bind="MainMenuBinds"
        @logout="logoutUserFromSite"
      />
    </q-layout-drawer>
    <active-component-common-modal-help-faq
      v-model="helpModal"
    />
  </q-layout>
</template>

<script>
  import NotificationBar from 'components/alert/notificationBar';
  import AccessibilityMenu from 'components/menu/header/accessibility/topMenu';
  import sideBarController from 'mixins/components/menu/side/SideBarController';
  import PageNameMixin from 'mixins/components/toolbar/header/pageName';
  import MainMenuMixin from 'mixins/modules/common/menu/main';
  import CordovaIosFixes from 'mixins/fixes/ios/cordova';
  import openMainMenuMixin from 'mixins/utils/menu/openMainMenu';

  export default {
    name: 'SubscriptionDefaultLayout',
    components: {
      NotificationBar,
      AccessibilityMenu,
      ActiveComponentCommonModalHelpFaq: () => import('activeComponent/common/modal/help/faq'),
      MainMenu: () => import('components/menu/side/main'),
      SimpleHeaderToolBar: () => import('components/toolBar/header/Simple'),
    },
    mixins: [sideBarController, PageNameMixin, MainMenuMixin, CordovaIosFixes, openMainMenuMixin],
    data() {
      return {
        teste: false,
        helpModal: false,
        fixedMenu: false,
      };
    },
    computed: {
      headerToolBarBinds() {
        const binds = {
          headerTitle: this.headerTitle,
        };
        if (this.$route.meta.backRoute) {
          Object.assign(binds, {
            backRoute: { name: this.$route.meta.backRoute },
            backButton: true,
          });
        }
        return binds;
      },
      buttonIcon() {
        if (this.SET_DISPLAY.helpMenu) return 'fas fa-question-circle';
        if (this.SET_DISPLAY.importantInformationMenu) return 'fas fa-info-circle';
        return '';
      },
    },
  };
</script>
